// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes LkmUIUVI6Mfv0dsPfBfi{from{opacity:0}to{opacity:1}}.Bemx70pt6XIrVPGmIHHc{height:100%;width:100%}@media(prefers-reduced-motion: no-preference){.Bemx70pt6XIrVPGmIHHc{animation-fill-mode:backwards;animation-name:LkmUIUVI6Mfv0dsPfBfi}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Bemx70pt6XIrVPGmIHHc`,
	"fadeInKeyFrame": `LkmUIUVI6Mfv0dsPfBfi`
};
export default ___CSS_LOADER_EXPORT___;
